/**
 * HEIC → JPEG in the browser: neither the chat models nor <img> previews read HEIC.
 * heic2any bundles libheif (~1MB), so it is loaded only when an HEIC file is picked.
 */
export async function convertHeicToJpeg(file: File): Promise<File | null> {
    try {
        const {default: heic2any} = await import('heic2any');
        const result = await heic2any({blob: file, toType: 'image/jpeg', quality: 0.9});
        const blob = Array.isArray(result) ? result[0] : result;
        if(!blob) {
            return null;
        }
        const name = `${file.name.replace(/\.hei[cf]$/i, '')}.jpg`;
        return new File([blob], name, {type: 'image/jpeg'});
    } catch {
        return null;
    }
}
